import React from 'react';
import dollars from '../../dollar-format';
import {executeQuery} from "../../requests/executeQuery";
import {renderPrintFooter} from "../../utils";
import {HSC_PIPELINE} from "../../consts/queries";
import {columns} from "./columns";
import {HscPipelineModel} from "./hscPipelineModel";
import LinkComp from "../LinkComp/LinkComp";

export default class HscPipeline extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rows: {},
            loading: false,
            isPrint: false,
            printBackground: '',
        };

        this.beforePrint = this.beforePrint.bind(this);
        this.afterPrint = this.afterPrint.bind(this);
    }

    fetch() {
        this.setState({loading: true});

        executeQuery({queryName: HSC_PIPELINE, params: {}}).then(res => {
            if (res && res.success && Array.isArray(res.data) && res.data.length) {
                const rows = new HscPipelineModel(res.data[0]);
                this.setState({rows, loading: false});
            }
        });
    }

    componentDidMount() {
        this.setState({printBackground: `url('${arc.path.media+'Transaction_Background.png'}')`}, this.fetch);
        window.onbeforeprint = this.beforePrint;
        window.onafterprint = this.afterPrint;
    }

    beforePrint() {
        this.setState({isPrint: true});
    }

    afterPrint() {
        this.setState({isPrint: false});
    }

    renderTable(columns, rows) {
        return (
            <table>
                <thead>
                <tr>
                    {
                        columns.map((column, index) => {
                            return <th key={index} className="Pipeline_th">{column.name}</th>
                        })
                    }
                </tr>
                </thead>
                <tbody>
                {
                    Object.keys(rows).map(key => {
                        return (
                            <tr key={key}>
                                {
                                    columns.map((column, index) => {
                                        let value = '';
                                        if (rows[key][column.key] !== null) {
                                            if (column.format === '$') {
                                                const withCents = column.withCents;
                                                value = dollars(rows[key][column.key], withCents);
                                            } else {
                                                value = rows[key][column.key];
                                            }
                                        }

                                        if (rows[key].url && index === 0)
                                            return (
                                                <td key={key+'-'+index}
                                                    className={column.class ? column.class : 'Pipeline_td'}>
                                                    <LinkComp to={`${arc.path.base}hsc-pipeline/${rows[key].url}`}>
                                                        {value}
                                                    </LinkComp>
                                                </td>
                                            );
                                        return (
                                            <td key={key+'-'+index}
                                                className={column.class ? column.class : 'Pipeline_td'}>
                                                {value}
                                            </td>
                                        )
                                    })
                                }
                            </tr>
                        );
                    })
                }
                </tbody>
            </table>
        );
    }

    render() {
        const {rows, loading, isPrint, printBackground} = this.state;
        const d = new Date();
        const date = d.getMonth()+1+'/'+d.getDate()+'/'+d.getFullYear();

        return (
            <div className='Pipeline'>
                <div className='print-container' style={{backgroundImage: isPrint && printBackground}}>
                    <div className='Pipeline_head'>
                        <div className="Pipeline_head_left">
                            <h3 className='Pipeline_h3'>HSC Pipeline</h3>
                            <h4 className='Pipeline_h4'>{date}</h4>
                        </div>
                    </div>
                    {
                        loading ?
                            <div className='loading'>Loading data...</div>
                            :
                            this.renderTable(columns, rows)
                    }
                    {renderPrintFooter(isPrint, true)}
                </div>
                <div className='preload-print-background' style={{backgroundImage: printBackground}}/>
            </div>
        );
    }
}
